import { Component, OnInit, ViewChild } from '@angular/core';
import { RmsModule } from "@rms";
import { InventoryDataService, lastValueFrom, PromptService } from "@services";
import { Column, TableIcon, HeaderButton } from '@interfaces';
import { CoffeeDataComponent } from './coffee-data/coffee-data.component';
import { CoffeeGroupingComponent } from './coffee-grouping/coffee-grouping.component';

@Component({
  selector: 'app-coffees',
  imports: [RmsModule, CoffeeDataComponent, CoffeeGroupingComponent],
  templateUrl: './coffees.component.html',
  styleUrl: './coffees.component.scss'
})
export class CoffeesComponent implements OnInit {
  @ViewChild(CoffeeDataComponent) coffeeData?: CoffeeDataComponent;
  constructor(private inventoryDataService: InventoryDataService, private prompt: PromptService) {}
  CoffeeProducts: any[] = [];
  ProductsColumns: Column[] = []
  SelectedProduct: any = null;
  Regions: any[] = [];
  Countries: any[] = [];
  NewProduct: boolean = false;
  ViewGrouping: boolean = false;
  HeaderButtons: HeaderButton[] = [
    { label: 'New SKU', onAction: () => this.CreateNewProduct() },
    { label: 'View Groups', onAction: () => this.ViewGroups() }
  ]
  async ngOnInit() {
    await this.refreshData();
  }
  async refreshData() {
    const data = await this.inventoryDataService.getData({ keys: ['Products'] });

    this.CoffeeProducts = data['Products'];
    this.ProductsColumns = [
      { label: 'SKU', key: 'InventoryTypeID', width: 20 },
      { label: 'Name', key: 'InventoryTypeName', width: 80 },
    ]
  }
  SelectProduct(product: any) {
    this.SelectedProduct = product.row;
  }
  BackToList() {
    this.SelectedProduct = null;
    this.NewProduct = false;
    this.ViewGrouping = false;
  }
  CreateNewProduct() {
    this.NewProduct = true;
    this.SelectedProduct = {}
  }
  async onNewProductCreated(InventoryTypeID: number) {
    this.BackToList();
    await this.refreshData();
    this.SelectedProduct = this.CoffeeProducts.find(p => p.InventoryTypeID === InventoryTypeID);
  }
  onSkuCancelled() {
    this.NewProduct = false;
    this.SelectedProduct = null;
  }
  async onSkuExists(InventoryTypeID: any) {
    this.BackToList();
    await this.refreshData();
    this.SelectedProduct = this.CoffeeProducts.find(p => p.InventoryTypeID === InventoryTypeID);
  }
  ViewGroups() {
    this.ViewGrouping = true;
  }
  async handleBackClick() {
    // if not even in SKU editor, just go back
    if (!this.coffeeData) {
      this.BackToList();
      return;
    }

    const hasChanges = this.coffeeData.hasUnsavedChanges();

    if (!hasChanges) {
      this.BackToList();
      return;
    }

    const action = await this.confirmLeave();

    if (action === 'save') {
      await this.coffeeData.submit();
      // submit already emits + refresh flow
      return;
    }

    if (action === 'discard') {
      this.BackToList();
    }

    // cancel → do nothing
  }
  async confirmLeave(): Promise<'save' | 'discard' | 'cancel'> {
    return new Promise(resolve => {
      const { closed$ } = this.prompt.open({
        promptText: 'You have unsaved changes. What would you like to do?',
        buttons: [
          { label: 'Save Changes', value: 'save', buttonClass: 'btn-bg-green' },
          { label: 'Discard Changes', value: 'discard', buttonClass: 'btn-bg-red' },
        ]
      });

      closed$.subscribe(result => resolve(result));
    });
  }
}
